module.exports = require("cfonts");


//////////////////
// WEBPACK FOOTER
// external "cfonts"
// module id = 56
// module chunks = 0